import BigNumber from 'bignumber.js';

import { OrderBookUpdateEntry, PriceSizeTuple } from '#/api/order-book';

import { OrderBook } from './types';

export interface OrderBookSpread {
  absolute: BigNumber;
  relative: BigNumber;
}

export function calculateSpread(orderBook: OrderBook): OrderBookSpread | null {
  const { asks, bids } = orderBook;

  if (asks.length === 0 || bids.length === 0) return null;

  const maxAsk = asks[asks.length - 1]![0];
  const maxBid = bids[0]![0];
  const absolute = maxAsk.minus(maxBid);
  const relative = absolute.dividedBy(maxAsk).multipliedBy(100);

  return {
    absolute,
    relative,
  };
}

export function isOrderBookEmpty({ asks, bids }: OrderBook): boolean {
  return asks.length === 0 && bids.length === 0;
}

function transformOrderBookEntryToTuple(
  entry: OrderBookUpdateEntry,
): PriceSizeTuple {
  return [entry.price, entry.size];
}

export function parseBids(entries: OrderBookUpdateEntry[]): PriceSizeTuple[] {
  return entries
    .filter((entry) => entry.side === 'BUY')
    .map(transformOrderBookEntryToTuple);
}

export function parseAsks(entries: OrderBookUpdateEntry[]): PriceSizeTuple[] {
  return entries
    .filter((entry) => entry.side === 'SELL')
    .map(transformOrderBookEntryToTuple);
}

export function parseIds(entries: OrderBookUpdateEntry[]): string[] {
  return entries.map((entry) => entry.price.toString());
}
